// Entry points served by the SPA.
export const DASHBOARD_PATH = "/dashboard/";
export const LOGIN_PATH = "/login";

export const ROWS_PER_PAGE: number[] = [10, 50, 100];
export const DEFAULT_PAGE_SIZE: number = ROWS_PER_PAGE[2] || 50;
export const HEADER_HEIGHT = 42;
export const ROW_HEIGHT = 24;
export const CALENDAR_ROW_HEIGHT = 34;
// Cursor → tooltip gap of every recharts chart (Reporting, Cockpit, Calendar).
export const CHART_TOOLTIP_OFFSET = 60;

/**
 * Defines the operators as strings
 */
export enum Operator {
  EQ = "eq",
  NEQ = "neq",
  GT = "gt",
  GTE = "gte",
  LT = "lt",
  LTE = "lte",
}

export const OPERATORS = [
  { name: Operator.GT, label: ">" },
  { name: Operator.GTE, label: ">=" },
  { name: Operator.LT, label: "<" },
  { name: Operator.LTE, label: "<=" },
  { name: Operator.EQ, label: "=" },
  { name: Operator.NEQ, label: "<>" },
];
